import { useFetch } from "../../custom/api";
import { useEffect, useState } from "react";
import LoadingPage from "../../components/LoadingPage";
import DietBanner from "./components/DietBanner";
import DietModal from "./components/DietModal";
import NoSubModal from "../../components/NoSubModal";
import { baseURL } from "../../custom/api";
import TopNavbarBack from "../../components/TopNavbarBack";

export default function Diets() {
  const { myFetch } = useFetch();
  const [dietPlans, setDietPlans] = useState(null);
  const [showDiet, setShowDiet] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [dietInfo, setDietInfo] = useState(null);
  const [steps, setSteps] = useState(null);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenDiet = (id) => {

    const dietInfo = dietPlans.filter((elem) => {
      return elem.diet_plan_id === id
    })[0]

    const steps = dietInfo.steps.split('@@').map(
      (elem, index) => {
        return {step_number: index + 1,
                step_description: elem}
      }
    )
    setSteps(steps)
    setDietInfo(dietInfo)
    setSelectedId(id)
    setShowDiet(true);
  };

  const handleCloseDiet = () => {
    setShowDiet(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch("diet-plans", { method: "GET" });
      const r = await resp.json();
      setDietPlans(r);
    };
    fetchData();
  }, []);

  return (
    <>
    <TopNavbarBack
        title="برنامه غذایی"
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={[null]}
        lbackground={[null]}
        className="fixedPosition"
      />
    <div className="marginSide5">
      {dietPlans === null ? (
        <LoadingPage />
      ) : (
        dietPlans.map((dietPlan) => {
          return (
            <DietBanner
              title={dietPlan.diet_plan_name}
              // linkTo = {`diet/${dietPlan.diet_plan_id}`}
              description={dietPlan.diet_plan_description}
              // tags={tags1}
              imgSrc={`${baseURL}/${dietPlan.diet_plan_image}`}
              status={dietPlan.is_premium ? "حرفه‌ای" : "رایگان"}
              statusTagClass={dietPlan.is_premium ? "statusTag b-green-1 white" : "statusTag b-blue-1 white"}
              onClick={
                dietPlan.active_status === "active"
                  ? () => handleOpenDiet(dietPlan.diet_plan_id)
                  : () => setShowModal(true)
              }
            />
          );
        })
      )}

      <DietModal
        showDiet={showDiet}
        handleOpenDiet={handleOpenDiet}
        handleCloseDiet={handleCloseDiet}
        dietId={selectedId}
        dietInfo={dietInfo}
        steps={steps}
      ></DietModal>

      <NoSubModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      ></NoSubModal>
    </div>
    </>
  );
}
